import { render } from "./Giphy.vue?vue&type=template&id=dc3ca920"
import script from "./Giphy.vue?vue&type=script&lang=js"
export * from "./Giphy.vue?vue&type=script&lang=js"

import "./Giphy.vue?vue&type=style&index=0&id=dc3ca920&lang=css"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__